import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const resources = {
  en: {
    translation: {
      login: "Login",
      domain: "Domain",
      username: "Username",
      password: "Password",
      hello: "Hello",
      invoices: "Invoices",
      fromDate: "From",
      toDate: "To",
      applyFilters: "Apply",
      exportToExcel: "Excel",
      previous: "Previous",
      next: "Next",
      home: "Home",
      loading: "Loading...",
      logout: "Logout",
      dashboard: "Dashboard",
      fortotikes: "Delivery List",
      uploadFortotikes: "Upload Deliveries",
      uploadInvoice: "Upload Invoice",
      tracking: "Tracking",
      pins: "Pins",
      contact: "Contact",
      statistics: "Statistics",
      exit: "Exit",
      errorFetchingData: "Error fetching data",
      noRecordsFound: "No records found",
      dataSavedSuccessfully: "Data saved successfully",
      deleteConfirmation: "Are you sure you want to delete this item?",
      page: "page",
      select: "Select",
      confirmLogout: "Are you sure you want to log out?",
      loggedOut: "You have successfully logged out.",
      //fortotiki list:
      entryDate: "Document Date",
      DocumentCode: "Document",
      CustomerDoc: "Customer Code",
      SenderName: "Sender Name",
      RecieverName: "Reciever Name",
      DeliveryAddress: "Address",
      DeliveryCity: "City",
      DeliveryStatus: "Status",
      CancellationReason: "Cancellation Reason",
      DeliveryRemarks: "Remarks",
      //kartela pelati
      CusCard: "Customer Card",
      DailyCustomerCard: "Daily Customer Card",
      Date: "Date",
      Debit: "Debit",
      Credit: "Credit",
      progressiveBalance: "Balance",
      noData: "No Data Available",
      Previous: "Previous",
      Next: "Next",
      Page: "Page",
      outOf: "Out of",
      Reasoning: "Reasoning ",
      errorDownloadingDocument: "Error downloading document",
      action: "Action",
      //Voucher Tracking
      search: "Search",
      UploadPDF: "Upload PDF Invoice File",
      Upload: "Upload!",
      Calendar:"Calendar",
      Projects:"Projects",
      NoProjects:"No Project Found",
      SearchProjects: "Search projects...",
      NoProjectsFound: "No projects match your search",
      Notes: "Notes",
      Subject: "Subject", 
      Remarks: "Remarks", 
      CreateNewNote: "Create New Note", 
      EditNote: "Edit Note",
      cancel:"Cancel",
      create:"Create",
      save:"Save",
      // ENGLISH webcrm
      WebCRM: "Web CRM",
      WebCRMDescription: "Manage your daily SoftOne orders and status in one place.",
      Refresh: "Refresh",
      Refreshing: "Refreshing...",
      SelectedDate: "Selected date",
      PreviousDay: "Previous day",
      NextDay: "Next day",
      Today: "Today",
      Schedule: "Schedule",
      Order: "Order",
      Orders: "Orders",
      TodaysOrders: "Today's orders",
      Pending: "Pending",
      Done: "Completed",
      Completed: "Completed",
      Canceled: "Canceled",
      SoftOne: "SoftOne",
      Connected: "Connected",
      Imerominia: "Date",
      Eteria: "Company",
      Katastasi: "Status",
      Oxima: "Vehicle",
      Odigos: "Driver",
      Pelatis: "Customer",
      Paradosi: "Delivery",
      Parastatika: "Documents",
      Sxolia: "Comments",
      EditableField: "This field can be edited",
      UnsavedChanges: "Unsaved changes",
      SxoliaPlaceholder: "Enter comments...",
      NoData: "No information available",
      MarkCompleted: "Complete",
      Completing: "Completing...",
      MarkCanceled: "Cancel",
      Canceling: "Canceling...",
      Save: "Save",
      Saving: "Saving...",
      Close: "Close",
      NoOrdersTitle: "No orders for this date",
      NoOrdersText: "No orders were returned from SoftOne for",
      CouldNotLoadOrders: "Could not load orders",
      TryAgain: "Try again",
      UntitledCustomer: "Customer",
      SoftOneOrdersError: "SoftOne could not return the orders.",
      UnableToLoadOrders: "Unable to load the orders.",
      SoftOneAppIdMissing: "SoftOne App ID is not available.",
      WebCRMMissingOrderId: "The order does not contain a valid ID.",
      WebCRMUnableToSave: "Unable to save the comments.",
      WebCRMUnableToComplete: "Unable to complete the order.",
      WebCRMUnableToCancel: "Unable to cancel the order.",
      Read: "Read"
          },
  },
  gr: {
    translation: {
      login: "Σύνδεση",
      domain: "Σύνδεσμος",
      username: "Όνομα χρήστη",
      password: "Κωδικός πρόσβασης",
      hello: "Γειά σου",
      invoices: "Τιμολόγια",
      fromDate: "Από",
      toDate: "Μέχρι",
      applyFilters: "Εφαρμογή",
      exportToExcel: "Excel",
      previous: "Προηγούμενη",
      next: "Επόμενη",
      home: "Αρχική",
      loading: "Φόρτωση...",
      logout: "Έξοδος",
      dashboard: "Πίνακας ελέγχου",
      fortotikes: "Λίστα Φορτωτικών",
      uploadFortotikes: "Φόρτωση Φορτωτικών",
      uploadInvoice: "Ανέβασμα Τιμολογίου",
      paraggelies: "Παραγγελίες",
      tracking: "Παρακολούθηση",
      pins: "Πυλώνες",
      contact: "Επικοινωνία",
      statistics: "Στατιστικά",
      exit: "Έξοδος",
      errorFetchingData: "Σφάλμα κατά την λήψη δεδομένων",
      noRecordsFound: "Δεν βρέθηκαν εγγραφές",
      dataSavedSuccessfully: "Τα δεδομένα αποθηκεύτηκαν με επιτυχία",
      deleteConfirmation: "Είστε σίγουροι ότι θέλετε να διαγράψετε αυτό το στοιχείο;",
      page: "Σελίδα",
      select: "Επιλέξτε",
      confirmLogout: "Είστε σίγουροι ότι θέλετε να αποσυνδεθείτε;",
      loggedOut: "Έχετε αποσυνδεθεί επιτυχώς.",
      //fortotiki list:
      entryDate: "Ημερομηνία",
      DocumentCode: "Παραστατικό",
      CustomerDoc: "Παραστατικό Πελάτη",
      SenderName: "Επωνυμία Αποστολέα",
      RecieverName: "Επωνυμία Παραλήπτη",
      DeliveryAddress: "Διεύθ.Παράδοσης",
      DeliveryCity: "Πόλη Παράδοσης",
      DeliveryStatus: "Κατάσταση",
      CancellationReason: "Αιτία Ακύρωσης",
      DeliveryRemarks: "Παρατηρήσεις",
      //kartela pelati
      CusCard: "Καρτέλα Πελάτη",
      DailyCustomerCard: "Ημερήσια Καρτέλα Πελάτη",
      Date: "Ημ/νία",
      Debit: "Χρέωση",
      Credit: "Πίστωση",
      progressiveBalance: "Υπόλοιπο",
      noData: "Δεν υπάρχουν διαθέσιμα δεδομένα",
      Previous: "Προηγούμενη",
      Next: "Επόμενη",
      Page: "Σελίδα",
      outOf: "Από τις",
      Reasoning: "Αιτιολογία ",
      errorDownloadingDocument: "Σφάλμα κατά τη λήψη του εγγράφου",
      action: "Ενέργεια",
      //Voucher Tracking
      search: "Αναζήτηση",
      UploadPDF: "Μεταφόρτωση Αρχείου Τιμολογίου PDF",
      Upload: "Μεταφόρτωση!",
      Calendar:"Ημερολόγιο",
      Projects:"Έργα",
      NoProjects:"Δε Βρέθηκαν Έργα",
      SearchProjects: "Αναζήτηση Έργων...", 
      NoProjectsFound: "Δεν υπάρχουν έργα που να αντιστοιχούν στην αναζήτησή σας.",
      Notes: "Σημειώσεις",
      Subject: "Θέμα",
      Remarks: "Παρατηρήσεις",
      CreateNewNote: "Δημιουργία Νέας Σημείωσης",
      EditNote: "Επεξεργασία Σημείωσης",
      cancel:"Ακύρωση",
      create:"Καταχώρηση",
      save:"Αποθήκευση",
      // GREEK webcrm
      WebCRM: "Web CRM",
      WebCRMDescription: "Διαχειριστείτε τις ημερήσιες εντολές και την κατάστασή τους.",
      Refresh: "Ανανέωση",
      Refreshing: "Ανανέωση...",
      SelectedDate: "Επιλεγμένη ημερομηνία",
      PreviousDay: "Προηγούμενη ημέρα",
      NextDay: "Επόμενη ημέρα",
      Today: "Σήμερα",
      Schedule: "Πρόγραμμα",
      Order: "Εντολή",
      Orders: "Εντολές",
      TodaysOrders: "Εντολές ημέρας",
      Pending: "Εκκρεμεί",
      Done: "Ολοκληρώθηκε",
      Completed: "Ολοκληρωμένες",
      Canceled: "Ακυρώθηκε",
      SoftOne: "SoftOne",
      Connected: "Συνδεδεμένο",
      Imerominia: "Ημερομηνία",
      Eteria: "Εταιρεία",
      Katastasi: "Κατάσταση",
      Oxima: "Όχημα",
      Odigos: "Οδηγός",
      Pelatis: "Πελάτης",
      Paradosi: "Παράδοση",
      Parastatika: "Παραστατικά",
      Sxolia: "Σχόλια",
      EditableField: "Το πεδίο μπορεί να τροποποιηθεί",
      UnsavedChanges: "Μη αποθηκευμένες αλλαγές",
      SxoliaPlaceholder: "Καταχωρήστε σχόλια...",
      NoData: "Δεν υπάρχουν διαθέσιμες πληροφορίες",
      MarkCompleted: "Ολοκλήρωση",
      Completing: "Ολοκλήρωση...",
      MarkCanceled: "Ακύρωση",
      Canceling: "Ακύρωση...",
      Save: "Αποθήκευση",
      Saving: "Αποθήκευση...",
      Close: "Κλείσιμο",
      NoOrdersTitle: "Δεν υπάρχουν εντολές για την ημερομηνία",
      NoOrdersText: "Δεν βρέθηκαν εντολές στο SoftOne για",
      CouldNotLoadOrders: "Δεν ήταν δυνατή η φόρτωση των εντολών",
      TryAgain: "Δοκιμάστε ξανά",
      UntitledCustomer: "Πελάτης",
      SoftOneOrdersError: "Το SoftOne δεν επέστρεψε τις εντολές.",
      UnableToLoadOrders: "Δεν ήταν δυνατή η φόρτωση των εντολών.",
      SoftOneAppIdMissing: "Δεν είναι διαθέσιμο το App ID του SoftOne.",
      WebCRMMissingOrderId: "Η εντολή δεν περιέχει έγκυρο κωδικό.",
      WebCRMUnableToSave: "Δεν ήταν δυνατή η αποθήκευση των σχολίων.",
      WebCRMUnableToComplete: "Δεν ήταν δυνατή η ολοκλήρωση της εντολής.",
      WebCRMUnableToCancel: "Δεν ήταν δυνατή η ακύρωση της εντολής.",
      Read: "Διαβάστηκε"
    },
  },
  ro: {
    translation: {
      login: "Log in",
      domain: "Domeniu",
      username: "Nume de utilizator",
      password: "Parola",
      hello: "Buna ziua",
      invoices: "Facturi",
      fromDate: "Data de început",
      toDate: "Data de sfârșit",
      applyFilters: "Aplică filtrele",
      exportToExcel: "Exportă în Excel",
      previous: "Anterior",
      next: "Următor",
      home: "Acasă",
      loading: "Se încarcă...",
      logout: "Deconectare",
      dashboard: "Tabloul de bord",
      fortotikes: "Lista Fortotikes",
      uploadFortotikes: "Încărcare Fortotikes",
      uploadInvoice: "Încărcați Factura",
      tracking: "Urmărire",
      pins: "Pini",
      contact: "Contact",
      statistics: "Statistici",
      exit: "Ieșire",
      errorFetchingData: "Eroare la obținerea datelor",
      noRecordsFound: "Nu au fost găsite înregistrări",
      dataSavedSuccessfully: "Datele au fost salvate cu succes",
      deleteConfirmation: "Ești sigur că vrei să ștergi acest element?",
      page: "pagină",
      select: "Selectați",
      confirmLogout: "Sunteți sigur că doriți să vă deconectați?",
      loggedOut: "Te-ai deconectat cu succes.",
      //fortotiki list:
      entryDate: "data documentului",
      DocumentCode: "document",
      CustomerDoc: "document client",
      SenderName: "Nume expeditor",
      RecieverName: "Numele destinatarului",
      DeliveryAddress: "Adresa de livrare",
      DeliveryCity: "Orașul de livrare",
      DeliveryStatus: "Situaţie",
      CancellationReason: "Motivul anulării",
      DeliveryRemarks: "Note de distribuție",
      //kartela pelati
      CusCard: "Cardul clientului",
      DailyCustomerCard: "Cardul zilnic al clientului",
      Date: "Data",
      Debit: "Debit",
      Credit: "Credit",
      progressiveBalance: "Progresiv",
      noData: "Nu există date disponibile",
      Previous: "Anterior",
      Next: "Următorul",
      Page: "Pagină",
      outOf: "De la",
      Reasoning: "rațiune",
      errorDownloadingDocument: "Eroare la descărcarea documentului",
      action: "Acțiune",
      //Voucher Tracking
      search: "Căutare",
      UploadPDF: "Încarcă Fișierul Factură PDF",
      Upload: "Încărcare",
      Calendar:"Calendaristic",
      Projects:"Proiecte",
      NoProjects:"Nu s-au găsit proiecte",
      SearchProjects: "Căutare proiecte...", 
      NoProjectsFound: "Niciun proiect nu corespunde căutării dvs." ,
      Notes: "Note",
      Subject: "Subiect",
      Remarks: "Observații",
      CreateNewNote: "Creează Notă Nouă",
      EditNote: "Editează Notă",
      cancel:"Anulează",
      create:"Creează",
      save:"Salvează",
      // ROMANIAN webcrm
      WebCRM: "Web CRM",
      WebCRMDescription: "Gestionați comenzile zilnice, informațiile de livrare și starea lor din SoftOne într-un singur loc.",
      Refresh: "Reîmprospătare",
      Refreshing: "Se reîmprospătează...",
      SelectedDate: "Data selectată",
      PreviousDay: "Ziua precedentă",
      NextDay: "Ziua următoare",
      Today: "Astăzi",
      Schedule: "Program",
      Order: "Comandă",
      Orders: "Comenzi",
      TodaysOrders: "Comenzile zilei",
      Pending: "În așteptare",
      Done: "Finalizată",
      Completed: "Finalizate",
      Canceled: "Anulată",
      SoftOne: "SoftOne",
      Connected: "Conectat",
      Imerominia: "Dată",
      Eteria: "Companie",
      Katastasi: "Stare",
      Oxima: "Vehicul",
      Odigos: "Șofer",
      Pelatis: "Client",
      Paradosi: "Livrare",
      Parastatika: "Documente",
      Sxolia: "Comentarii",
      EditableField: "Acest câmp poate fi editat",
      UnsavedChanges: "Modificări nesalvate",
      SxoliaPlaceholder: "Introduceți comentarii...",
      NoData: "Nu există informații disponibile",
      MarkCompleted: "Finalizează",
      Completing: "Se finalizează...",
      MarkCanceled: "Anulează",
      Canceling: "Se anulează...",
      Save: "Salvare",
      Saving: "Se salvează...",
      Close: "Închidere",
      NoOrdersTitle: "Nu există comenzi pentru această dată",
      NoOrdersText: "SoftOne nu a returnat comenzi pentru",
      CouldNotLoadOrders: "Comenzile nu au putut fi încărcate",
      TryAgain: "Încearcă din nou",
      UntitledCustomer: "Client",
      SoftOneOrdersError: "SoftOne nu a returnat comenzile.",
      UnableToLoadOrders: "Comenzile nu au putut fi încărcate.",
      SoftOneAppIdMissing: "SoftOne App ID nu este disponibil.",
      WebCRMMissingOrderId: "Comanda nu conține un ID valid.",
      WebCRMUnableToSave: "Comentariile nu au putut fi salvate.",
      WebCRMUnableToComplete: "Comanda nu a putut fi finalizată.",
      WebCRMUnableToCancel: "Comanda nu a putut fi anulată.",

    },
  },
};

const languageDetector = {
  type: "languageDetector",
  async: true,
  detect: async (callback) => {
    const storedLanguage = localStorage.getItem("appLanguage"); 
    callback(storedLanguage || "gr"); // Default to 'gr' if not found
  },
  init: () => {},
  cacheUserLanguage: (lng) => {
    localStorage.setItem("appLanguage", lng);
  },
};

i18n
  .use(languageDetector)
  .use(initReactI18next)
  .init({
    compatibilityJSON: "v3",
    resources,
    keySeparator: false,
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
  });

export default i18n;
